export const colour_lookup = (colour) => {
  
  const options = {
    green: '#9FE247',
    red: '#F25050',
    amber: '#FCE051',
    blue: '#32A3F5',
    dark_blue: '#233567',
    grey: '#707070',
    light_grey: '#cfcfcf',
    pink: '#fbc2c4',
    white: '#ffffff'
  }
  
  if (typeof colour === 'undefined' || colour === null) return options.grey;
  
  return options[colour];
}

export const connectivity_colour_lookup = (connectivity) => {
  
  if (typeof connectivity === 'undefined' || connectivity === null) return colour_lookup('grey')
  
  const options = {
    'online': colour_lookup('green'),
    'offline': colour_lookup('red'),
    'not_measuring': colour_lookup('grey'),
    'delayed': colour_lookup('amber'),
    'unbuffering': colour_lookup('amber'),
    'power_saving': colour_lookup('blue')
  }
  
  return options[connectivity];
}